<!--
	Контрол - аналог обычной выпадушки, но с мультивыбором, фильтрацией и проч.
	Для больших справочников надо юзать контрол Выбор записи
-->

<template>
	<div v-bind="c_test_attrs" :style="wrapStyle">

		<!-- Обычный вид мультивыбора ("выпадушка") -->
		<div v-if="!c_ctrlParams.isCheckbox">
			<VueMultiselect v-model="c_value_4multiselect" :options="c_srv_options" :multiple="true"
				:close-on-select="false" :clear-on-select="true" :preserve-search="false" selectLabel="Выбрать"
				selectedLabel="Выбрано" deselectLabel="Отменить" :placeholder="inputPlaceholder" label="name"
				:maxHeight="700" track-by="id" :preselect-first="false" ref="multiselectComponent"
				@open="msOpened = true" @close="msOpened = false">
				<!-- ☑ ✓ ✔ ✕ ✖ Нажмите чтобы отменить выбор-->

				<template slot="selection" slot-scope="{ values, search, isOpen }">
					<span class="multiselect__single" v-show="values.length || isOpen"> <!-- values.length !isOpen -->
						<template v-if="values.length < maxSelectedView">
							<span v-for="v in values" :key="v.name" class="multiselect__tag"
								v-html="v.name"></span><!-- v-html потому что например в опросах-2013 в поле возраст есть значок бесконечности -->
						</template>
						<template v-if="values.length >= maxSelectedView">
							Выбрано значений: {{ values.length }}
						</template>
					</span>
				</template>

				<template slot="noResult">По Вашему фильтру ничего не найдено</template>

				<template slot="noOptions">Список пуст</template>

				<template slot="caret">
					<i ref="icon" class="lm-dropdown-icon"></i>
				</template>

				<template slot="option" slot-scope="props"> <!-- props можно заменить на {option, search} -->
					<div v-if="props.option.OPTION_HINT" class="multiselect__my-option-hint">
						{{ props.option.OPTION_HINT }}!!
					</div>
					<template v-if="props.option.tree_level - 1">↳</template>
					<span v-html="props.option.name"></span>
					<!-- v-html потому что например в опросах-2013 в поле возраст есть значок бесконечности -->
				</template>
			</VueMultiselect>
		</div>

		<!-- Вид мультивыбора "пачка чекбоксов" для небольшого количества опций -->
		<div v-if="c_ctrlParams.isCheckbox">
			<div v-for="opt in c_srv_options" :key="opt.id">
				<label class="font-normal">
					<input type="checkbox" :checked="($props.value || []).includes(opt.id)"
						@input="dispatchCheckboxInput($event, opt.id)" /> {{ opt.name }}
				</label>
			</div>
		</div>
		<div class="help-block"></div>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
	import ctrlMixins from './_mixins.js'
	import VueMultiselect from 'vue-multiselect' // https://vue-multiselect.js.org/
	require('vue-multiselect/dist/vue-multiselect.min.css')
	import { ctrlParamsForAll } from './_common-stuff.ts';

	export default {
		name: 'ctrl_multiselect',
		meta: { // это наши данные, т.е. вуй при объявлении компонента их не использует
			title: 'Мультивыбор',
			params: {
				isCheckbox: {
					name: 'Чекбоксы',
					editType: 'checkbox',
					tip: 'Мультивыбор превращается в пачку чекбоксов. Актуально для небольшого количества опций. Используйте префильтры контрола на кросстаблице, если их больше пяти.',
				},
				...ctrlParamsForAll,
			}
		},
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				type: Array,
				default: function(){
					return []
				}
			},
		},
		data: function(){
			return {
				maxSelectedView: 5,
				wrapStyle: this.$props.view_type === 'filter' ? 'min-width: 300px' : '',
				msOpened: false,
			}
		},
		mounted: function(){
			// console.log(this.c_value, this.c_value_4multiselect)
		},
		methods: {
			EXT_triggerFocus: function(){ // при создании записи фокус по умолчанию на первый элемент формы
				this.$refs.multiselectComponent.activate();
			},
			// для !isCheckbox подобную задачу выполняет c_value_4multiselect
			dispatchCheckboxInput: function (evt, optId) {
				let valueCopy = this.value ? [...this.value] : []; // защита от null который почему-то отдает сервер если рубрик нет
				if (evt.target.checked) {
					if (!valueCopy.includes(optId)) valueCopy.push(optId);
				}
				else {
					valueCopy = valueCopy.filter(id => id !== optId);
				}
				// присваиваем через сеттер c_value_4multiselect, чтобы держать служебные штуки там
				this.c_value_4multiselect = this.c_srv_options.filter(opt => valueCopy.includes(opt.id));
			},
		},
		components: {
			VueMultiselect,
		},
		computed: {
			inputPlaceholder: function(){
				return this.$data.msOpened ? 'Поиск...' : '-- Выберите значение --';
			},
			c_value_4multiselect: {
				// на вход получаем массив айдишников (см. также аналогичный компьютед в popup_picker.vue)
				// а плагин ждет в велью массив объектов (выбранные выбираются по track-by)
				// для isCheckbox подобную задачу выполняет dispatchCheckboxInput
				get: function() {
					var compatValue = [];
					var outerValue = this.value || []; // защита от null который почему-то отдает сервер если рубрик нет

					valLoop: for (var i = 0; i < outerValue.length; i++) {
						var optId = outerValue[i];
						optLoop: for (var k = 0; k < this.c_srv_options.length; k++) {
							var opt = this.c_srv_options[k];
							if (opt.id === optId) {
								compatValue.push(opt)
								break optLoop;
								//continue valLoop;
							}
						}

					}
					return compatValue;
				},
				set: function(newVal) {
					// соответственно и на выход тоже отдаем массив айдишников
					this.$emit('update:value', newVal.map(function(item) {
						return item.id;
					}));
					this.mixin_inputEvent({
						ctrlCode: this.$props.field_meta.ctrlCode,
						dbcolname: this.$props.field_meta.dbcolname,
						evtType: 'set',
						fullValue: newVal.map(function(item) {
							return {
								id: item.id,
								name: item.name,
								REVERT_VALUE_TO_PLAIN: true,
							}
						})
					});
					this.mixin_saveEvent();
				}
			}
		},
	}
</script>

<style>
.multiselect,
.multiselect__input,
.multiselect__single {
	font-size: 13px;
}

.multiselect__input,
.multiselect__single {
	margin-bottom: 0;
}

.multiselect__tag {
	margin-bottom: 0;
	padding-right: 10px;
}

.multiselect__tag,
.multiselect__option--highlight,
.multiselect__option--highlight:after {
	color: #1F1F24;
	background-color: #EBF6FE;
}

.multiselect__option--selected {
	font-weight: normal;
}

.multiselect__option--selected.multiselect__option--highlight {
	background: #ffa0a0;
	color: #fff;
}

.multiselect__option--selected.multiselect__option--highlight:after {
	background: #ffa0a0;
	content: attr(data-deselect);
	color: #fff;
}

.multiselect__select {
	height: 28px;
	/*padding-top: 1px;*/
}

.multiselect__tags {
	min-height: 28px;
	/* как input-sm */
	padding-top: 3px;
	padding-left: 2px;
	border: 1px solid #ccc;
	border-radius: 2px;
}

.multiselect__placeholder {
	margin-bottom: 0;
}

.multiselect__placeholder,
.multiselect__input::placeholder {
	font-size: 12px;
	color: #333;
}

.multiselect__placeholder {
	text-indent: 10px;
	cursor: default;
}

.multiselect__input::placeholder {
	text-indent: 6px;
}

.multiselect__my-option-hint {
	color: grey;
	font-size: .8em;
	margin-top: -4px;
}

.multiselect__option--highlight .multiselect__my-option-hint {
	color: #dedede;
}

.multiselect--above {
	z-index: 7;
	/* хз что это! */
}

.multiselect__content-wrapper {
	z-index: 7;
	/* PIRS2018-2001 */
	margin-top: 0px;
	box-shadow: none;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
}
</style>
